import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IUser } from '@orgacard/login';

import { BetterRequestService } from '@services';

import { AppService } from '../app.service';
import { CoreService } from './core.service';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class PrivilegeService {
    private http = inject(HttpClient);
    private readonly betterRequestService = inject(BetterRequestService);
    private environmentService = inject(EnvironmentService);
    appService = inject(AppService);
    private coreService = inject(CoreService);

    constructor() {
        if (this.environmentService.appSettings.showLog) console.log(new Date() + ': ' + 'privilege.service.ts - constructor START');
        //
        if (this.environmentService.appSettings.showLog) console.log(new Date() + ': ' + 'privilege.service.ts - constructor ENDE');
    }

    getSystemPrivilegesByFake(): Observable<boolean> {
        if (this.environmentService.appSettings.showLog) {
            console.log(new Date() + ': ' + 'core.service.ts - getGenders START');
        }
        const headers = this.environmentService.appSettings.headers;
        // const url: string = this.environmentService.getURL(true) + '/systemuser/connect';
        const url = window.location.protocol + '//' + window.location.host + window.location.pathname + 'assets/rest/privileges.json';

        return this.betterRequestService
            .withoutErrorHandler(
                this.http.get<IUser>(url, {
                    headers: this.environmentService.appSettings.headers,
                    observe: 'response',
                }),
            )
            .pipe(
                map((response) => {
                    const privileges = response.body.privileges.map((priv) => priv.replace(/\*/g, '**'));
                    this.environmentService.systemUser.privileges = privileges;
                    return true;
                }),
                catchError(this.coreService.handleError),
            );
    }
}
